import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { TransactionResult } from '../../../../../core/services/interfaces/transaction-result';
import { IDocumentsTypes } from '../../Interfaces/IDocumentsTypes';
import { DocumentsTypesService } from '../../services/documentstypes-service';
import { TranslateApplicationService } from '../../../../../core/translate/translate-application-service';

@Component({
  selector: 'app-documenttype-detail',
  templateUrl: './documenttype-detail.component.html',
  styleUrls: ['./documenttype-detail.component.scss']
})
export class DocumenttypeDetailComponent {
  formGroup: FormGroup;
  loading = false;
  max_characters: string = "";

  constructor(
    private dialogRef: MatDialogRef<DocumenttypeDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDocumentsTypes,
    private notificationService: NotificationService,
    private documentsTypesService: DocumentsTypesService,
    private formBuilder: FormBuilder,
    public translate: TranslateApplicationService
  ) {
    this.formGroup = this.formBuilder.group({
      pkdocumenttype: [data.pkdocumenttype == null ? 0 : data.pkdocumenttype],
      txtdocumenttype: [
        data.documenttype,
        [
          Validators.required
        ]
      ],
      txtdescription: [
        data.description,
        [
          Validators.required,
          Validators.maxLength(255),
          Validators.pattern('.*[a-zA-Z].*')
        ]
      ]
    });
  }

  ngOnInit(): void {
    let max_char = this.translate.TranslateKey('max_characteres');
		this.max_characters = max_char.replace('{{ number_max }}', '255');
  }

  //button save for add/edit
  Save() {
    if (this.formGroup.valid) {
      this.loading = true;
      if (this.formGroup.controls.pkdocumenttype.value == 0) {
        this.documentsTypesService.CreateDocumentType(this.formGroup.value).subscribe(
        (result: TransactionResult<boolean>) => {
          this.loading = false;
          if (result.success) { 
            this.Alert(); this.dialogRef.close(true); 
          }
          else{
            this.ErrorAlert(result.message); this.dialogRef.close(true); 
          }
        },
        (error: any) => { 
          this.ErrorAlert(error); this.loading = false; 
        });
      }
      else {
        this.documentsTypesService.UpdateDocumentType(this.formGroup.value).subscribe(
        (result: TransactionResult<boolean>) => {
          this.loading = false;
          if (result.data) { 
            this.Alert(); this.dialogRef.close(true); 
          }
          else{
            this.ErrorAlert(result.message); this.dialogRef.close(true); 
          }
        },
        (error: any) => { 
          this.ErrorAlert(error); this.loading = false; 
        });
      }
    }
    else{
      this.notificationService.AddAlert({
        icon: 'all_inbox',
        title: 'Warning',
        message: this.translate.TranslateKey('COMPLETE_FORM'),
        shown: true
      });
    }
  }


  Close() {
    this.dialogRef.close(false);
  }

  Alert() {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Success',
      message: this.translate.TranslateKey('COMPLETE'),
      shown: true
    });
  }

  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
 	}
}
